export enum ChangeType {
	Create = "Create",
	Edit = "Edit",
	UnPublish = "UnPublish",
	Rollback = "Rollback"
}
